/**
 * Used in SGEvent.Broadcast
 * @property {Function} checkoutSubmit
 * @property {Function} checkoutRelease
 */
class SGEventBroadcast {
  constructor() {
    this.declare = this.declare.bind(this);
    this.register = this.register.bind(this);
  }

  /**
   * This is an event function factory. Use it to declare all events that may be broadcasted.
   * @param {string} eventName - name of event to declare
   */
  declare(eventName) {
    this[eventName] = function () {
      if (typeof this.__dispatch === 'function') {
        this.__dispatch(eventName, arguments);
      }
    };
  }

  /**
   * This function will register the current view to
   * receive SGEvent broadcasts for the given event names
   * Accepts an array of strings (event names)
   */
  register() {
    if (typeof this.__register === 'function') {
      this.__register(arguments);
    }
  }

  declareAll() {
    this.declare('updateCartBadge');
    this.declare('updateMenuBarCtaButton');
    this.declare('menuBarCtaButtonPressed');
    this.declare('reloadCart');
    this.declare('checkoutSubmit');
    this.declare('checkoutRelease');
    this.declare('reloadCheckout');
    this.declare('updateFavouriteListData');
    this.declare('reloadFavouriteList');
    this.declare('tabDidChange');
    this.declare('showPreviousTab');
    this.declare('userLoggedIn');
    this.declare('userLoggedOut');
    this.declare('hideLoadingScreen');
    this.declare('openKeyboard');
    this.declare('clickFavouriteList');
    this.declare('updateFavouriteListIcon');
    this.declare('mainViewWillDisappear');
    this.declare('mainViewDidDisappear');
    this.declare('mainViewWillAppear');
    this.declare('mainViewDidAppear');
    this.declare('mainViewWillBeReplaced');
    this.declare('menuBarDidAppear');
    this.declare('menuBarDidDisppear');
    this.declare('viewDidAppear');
    this.declare('updateImageGallery');
    this.declare('checkCartViewCount');
    this.declare('setLocation');
    this.declare('submitCurrentForm');
    this.declare('reloadReviews');
    this.declare('updateSgData');
    this.declare('cartQuantitiesChanged');
    this.declare('tabCheckedIn');
    this.declare('tabsPleaseCheckIn');
    /**
     * Params required: {
     *  state: boolean (true if busy)
     *  mainViewPageInformation: pageInformation (sender)
     * }
     */
    this.declare('mainViewBusyState');
    /* TabletAppEvents */
    this.declare('categoryListToggle');
    this.declare('serviceMenuToggle');
    /* Jaide Events */
    this.declare('toggleMenuBar');
    this.declare('updateStatusBarVisibility');
    /* Specific iOS 8 Template Events */
    this.declare('setEditMode');
    this.declare('updateFilterNotification');
    this.declare('replacePageInMainContent');
    this.declare('buttonInNavigationBarClicked');
    this.declare('updateForm');
    this.declare('genericNotificationPrimaryButtonClicked');
    this.declare('removePage');
    this.declare('reloadCheckoutPayment');
    /* Scanner did scan credit card (iOS 8 Template only at the moment)  */
    this.declare('creditCardScanned');
    this.declare('closeNotification');
    this.declare('appStartDone');
    this.declare('openDeferredDeepLink');
    this.declare('trackEvent');
    /**
     * Event for generic, universal purpose/usage.
     * Use it whatever you like, but please stick to
     * the params below:
     * {
     *  owner: [pageInformation.pageId] (optional, pageId identifier)
     *  receiver: [tabName which should receive the event]
     *  eventName: [custom event name]
     *  eventParams: [custom event params] (optional)
     * }
     *
     * Also, check see jquery.shopgate-ajax-forms-notifications.js for use cases.
     *
     */
    this.declare('universalEvent');
    this.declare('handleShowIntercom');
    /**
     * Shopgate Cloud Events
     * Events that are used within the new system (GMD)
     */
    this.declare('checkoutSuccess');
    // TODO: Remove as soon as all GMD live shops are re-deployed
    this.declare('backToHomepage');
  }
}

export default SGEventBroadcast;



// WEBPACK FOOTER //
// ./Library/1.0/app/sg-event/SGEventBroadcast.js